import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.css";
import Logo from './src/logo.png';
import Carousel from "./components/Carousel/Carousel.tsx";
import Menu from "./components/Menu/menu.tsx";
import Features from "./components/Features/features.tsx";
import Clientes from "./components/Clientes/clientes.tsx";
import Planos from "./components/Planos/planos.tsx";
import Contato from "./components/Contato/contato.tsx";
import QuemSomos from "./components/QuemSomos/quemsomos.tsx";

function Home() {

    return (
        <div className="d-flex flex-column vh-100">
            <header>
                <div className="container header-container">
                    <img src={Logo} alt="Links Vibe" className="header-logo" />
                    <Menu />
                </div>
            </header>
            <main className="flex-grow-1">
                <Carousel />
                <Features />
                <Clientes />
                <Planos />
                <QuemSomos />
            </main>
            <footer style={{ backgroundColor: "#000" }}>
                <div className="container">
                    <p className="mb-0">&copy; 2026 Links Vibe. Todos os direitos reservados.</p>
                </div>
            </footer>
        </div>
    );
}

export default Home;
